import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbInputDatepicker, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { EventService } from '../../../core/services/event.service';
import { ImageService } from '../../../core/services/image.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../../core/services/user.service';
import { ImageModalComponent } from '../../../core/components/dialogs/image-modal/image-modal.component';
import {Angulartics2} from "angulartics2";

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'main-tab-personal',
    templateUrl: './personal.component.html',
    styleUrls: ['../profile.page.scss']
})
export class PersonalComponent implements AfterViewInit, OnInit {
    @Input() dictData: any;
    @Output() onInit = new EventEmitter();
    @ViewChild('personalForm', { static: true }) form;
    @ViewChild('d', { static: true }) datePicker: NgbInputDatepicker;

    model: any;
    imageModel: any;

    dob: any = {};
    dobMinDate: NgbDateStruct;
    dobMaxDate: NgbDateStruct;
    currentImage: any = {
        imagePath: null
    };
    state: any = {
        isSubmitted: false
    };
    isProcessingRequest: boolean;

    constructor(
        private eventService: EventService,
        private imageService: ImageService,
        private modalService: NgbModal,
        private http: HttpClient,
        private toastr: ToastrService,
        private userService: UserService,
        private angulartics2: Angulartics2
    ) {
        let today = moment.utc();
        this.dobMinDate = {
            day: 1,
            month: 1, //The NgbDateStruct seems to use 1-12 for months
            year: 1900
        };
        this.dobMaxDate = {
            day: today.date(),
            month: today.month() + 1, //moment returns a 0-index month, but the NgbDateStruct expects a 1-index month
            year: today.year()
        };
    }

    ngOnInit() {
        this.convertToModels(this.eventService.selectedEvent.gql);
        this.eventService.onEventChange.subscribe(event => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
        this.onInit.emit(this.form);
    }

    ngAfterViewInit() {
        //If we change our prefix and we haven't selected an image, make sure the profile silhouette changes too
        this.eventService.onGqlReload.subscribe(() => {
            this.currentImage.imagePath = this.imageService.formatUrl(
                this.eventService.selectedEvent.gql.Participant[0].individualConstituent.imagePath
            );
        });
    }

    openProfilePictureChangeModal() {
        let modal = this.modalService.open(ImageModalComponent);
        modal.result.then(result => {
            if (result) {
                return this.userService.saveUserImage(result.constituentImageLibraryId).subscribe(() => {
                    this.eventService.getPersonalImage(true).subscribe(() => {});
                    this.currentImage.imagePath = result.imagePath;
                }, err => {
                    console.log(err);
                    this.toastr.error('Upload failed');
                });
            }
        }, () => {/* avoids error on 'cancel' */});
    }

    toggle(d: any) {
        d.toggle();
        setTimeout(() => {
            $('.ngb-dp-day .bg-primary').click(function() {
                d.close();
            });
        }, 0);
    }

    reverseParseDob() {
        // convert date format to timestamp
        if (this.dob) {
            let birthDate = new Date();
            birthDate.setDate(this.dob.day);
            birthDate.setMonth(this.dob.month - 1); //javascript date expects a 0-index month, but the NgbDateStruct expects a 1-index month
            birthDate.setFullYear(this.dob.year);
            this.model.dateOfBirth = birthDate.getTime(); //in javascript getTime() returns the number of milliseconds, which is what java wants
        }
    }

    onSubmit() {
        this.state.isSubmitted = true;
        this.isProcessingRequest = true;
        if (!this.form.valid) {
            this.isProcessingRequest = false;
            return;
        }
        this.http.post('/api/v1/user', this.model)
            .subscribe(res => {
                this.form.form.markAsPristine();
                this.eventService.getPersonal(true).subscribe(() => {});
                this.toastr.success('Personal details updated');
                this.angulartics2.eventTrack.next({
                    action: 'Save Profile',
                    properties: {category: 'Profile'}
                });
                this.isProcessingRequest = false;
            }, err => {
                this.toastr.error("There was a problem updating your profile");
                this.isProcessingRequest = false;
            });
    }

    convertToModels(gqlRes) {
        let constituent = gqlRes.Participant[0].individualConstituent;
        this.model = {
            firstName: constituent.firstName,
            lastName: constituent.lastName,
            middleInitial: constituent.middleInitial,
            suffix: constituent.suffix,
            dateOfBirth: constituent.dateOfBirth,
            prefixType: {
                prefixTypeId: (constituent.prefixType ? constituent.prefixType.cmgmtPrefixTypeId : null),
                name: (constituent.prefixType ? constituent.prefixType.name : null)
            }
        };
        this.imageModel = {
            llsImageId: constituent.imageId,
            imagePath: constituent.imagePath
        };

		//this is the function that handles the number of milliseconds since the epoch (java returns milliseconds)
		let dobDate = moment(this.model.dateOfBirth);

        this.dob = {
            day: dobDate.date(),
            month: dobDate.month() + 1, //moment returns a 0-index month, but the NgbDateStruct expects a 1-index month
            year: dobDate.year()
        }
        this.currentImage.imagePath = this.imageService.formatUrl(this.imageModel.imagePath);
    }

    actionButtonsEnabled() {
        return this.form && this.form.dirty && !this.isProcessingRequest;
    }
}
